import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { SuburbAddEditComponent, SuburblistComponent } from '@user/components/suburb';

const routes: Routes = [
  { path: 'list', component: SuburblistComponent, canActivate: [AuthGuard], data: { title: 'Suburb' } }
];
@NgModule({
  declarations: [SuburbAddEditComponent, SuburblistComponent],
  imports: [
    RouterModule.forChild(routes),
    LayoutModule,
    MaterialModule,
    SharedModule
  ],
  entryComponents: [SuburbAddEditComponent]
})
export class SubUrbModule { }